import React from 'react';
import {useTranslation} from 'react-i18next';
import {Typography} from 'antd';

const {Text} = Typography;

interface EquipmentTableProps {
  children?: React.ReactNode;
  editable?: boolean;
}

export const EquipmentTable: React.FC<EquipmentTableProps> = ({children, editable = true}) => {
  const {t} = useTranslation();

  return (
    <table className="equipment-table">
      <thead>
        <tr>
          <th className="w-[11rem]">
            <Text strong>{t('Name')}</Text>
          </th>
          <th className="w-[4.375rem]">
            <Text strong>{t('Count')}</Text>
          </th>
          <th className="w-[9.375rem]">
            <Text strong>{t('Status')}</Text>
          </th>
          <th>
            <Text strong>{t('Description')}</Text>
          </th>
          <th>
            <Text strong>{t('Location')}</Text>
          </th>
          <th className="w-[8rem]">
            <Text strong>{t('Added date')}</Text>
          </th>
          {editable && (
            <th className="w-[3rem] pr-0">
              <Text strong>{t('Action')}</Text>
            </th>
          )}
        </tr>
      </thead>
      <tbody>{children}</tbody>
    </table>
  );
};
